<template>
  <div :class="`page-loader ${isLoading ? 'is-open' : ''}`">
    <div>
      <div class="loader"></div>
      <span class="sr-only">{{ i18n.oneMomentPlease }}&hellip;</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'isLoading',
    ]),
  },
};
</script>
